import { render, staticRenderFns } from "./ModulesConfig.vue?vue&type=template&id=3190db33&scoped=true"
import script from "./ModulesConfig.vue?vue&type=script&lang=ts"
export * from "./ModulesConfig.vue?vue&type=script&lang=ts"
import style0 from "./ModulesConfig.vue?vue&type=style&index=0&id=3190db33&prod&lang=less"
import style1 from "./ModulesConfig.vue?vue&type=style&index=1&id=3190db33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190db33",
  null
  
)

export default component.exports